import styled from 'styled-components';

export const MessageLabel = styled.div`
  background: #66cc00;
  color: #fff;
  font-weight: 900;
  padding: 0.75rem;
  border-radius: 5px;
  font-size: 13px;
  margin: 0.5rem 0;
  width: fit-content;
`;

export const DisabledAction = styled.p`
  color: #71757b;
  text-decoration: underline;
`;

export const MessageMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MessageOrderLocked = styled.div`
  font-size: 14px;
  color: #71757b;
  font-weight: 500;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
`;

export const PaginationContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 25px;
  box-shadow: 1px 1px 5px 0 #d5d5d5;
  height: 48px;
  margin: 8px 0 28px !important;
  padding: 1rem;
`;

export const PageButtons = styled.button`
  background-color: #fff !important;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: default;
  font-weight: 500;

  &: hover {
    border-color: #4b286d;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const ActivePage = styled.button`
  background-color: #4b286d !important;
  color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: default;
  font-weight: 500;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const NaviagationButtonText = styled.p`
  font-size: 24px;
  margin-top: -7px;
`;

export const NaviagationButtons = styled.button`
  background-color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: default;
  color: #4b286d;
  font-weight: 500;
  align-item: center;

  &: hover {
    background-color: #f7f7f8 !important;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;
